import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { intl } from '../../../../locales/localesConfig';
import EngineFunctionsDefinition from '../../../../definitions/engineFunctionsDefinition';
import LocaleTooling from '../../../../tooling/localeTooling';
import Constants from '../../../../definitions/constants';

const HoverTooltip = props => {
  const {
    toolTip,
    toolTipType,
    placement,
    enterDelay,
    leaveDelay,
    classes,
  } = props;
  
  if(!toolTip) return null

  let finalDescription = ""
  
  switch(toolTipType) {
    case Constants.interface.toolTip.formulaDraggable:
      let description = "<p>"+LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionDescriptions." + toolTip + ".description"}))+"</p>"

      let paramsLength = EngineFunctionsDefinition.functionsList[toolTip].tooltipDescription.paramCases ? EngineFunctionsDefinition.functionsList[toolTip].tooltipDescription.paramCases : EngineFunctionsDefinition.functionsList[toolTip].params.length;
      let parameters = "<b>"+LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionDescriptionsTitles.parameters"}))+"</b>:<ul>";
      for(let i = 1; i <= paramsLength; i++){
        parameters += "<li>"+LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionDescriptions." + toolTip + ".parameters." + i})) + "</li>";
      }
      parameters += "</ul>";

      let functionReturnLength = EngineFunctionsDefinition.functionsList[toolTip].tooltipDescription.returnCases ? EngineFunctionsDefinition.functionsList[toolTip].tooltipDescription.returnCases : 1;
      let functionReturn =  "<b>"+LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionDescriptionsTitles.return"}))+"</b>"+":<ul>";
      for(let i = 1; i <= functionReturnLength; i++){
        functionReturn += "<li>"+LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.functionDescriptions." + toolTip + ".return." + i})) + "</li>";
      }
      finalDescription = description + parameters + functionReturn;
      break;
    case Constants.interface.toolTip.formItemHelp:
      finalDescription = "<p>"+toolTip+"</p>";
      break;
    case Constants.interface.toolTip.formSectionHelp:
      finalDescription = "<p>"+toolTip+"</p>";
      break;
    default:
      finalDescription = "<p>"+toolTip+"</p>";
  }

  return (
    <Tooltip title={<div dangerouslySetInnerHTML={{ __html: finalDescription}}/>} placement={placement} enterDelay={enterDelay} leaveDelay={leaveDelay} classes={classes}>
      {props.children}
    </Tooltip>
  )
}

export default HoverTooltip;


// WEBPACK FOOTER //
// ./source/client/components/common/interface/hoverTooltip.jsx